import {Autoplay, Navigation, Swiper, Pagination} from "swiper";
import {breakpointDown} from "../utils/breakpoints";

$('.js-single-product-header-slider').each(function (i, el) {

    let swiper = new Swiper(el, {
      modules: [Autoplay, Navigation, Pagination],
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      // autoplay: {
      //   delay: 5000,
      // },
      //speed: 600,
    })

})


if (breakpointDown('xl')) {
  $('.part-single-product-header .icon-c').click(function (e) {
    let curEl = this
    $(this).toggleClass('hovered')

    $('.part-single-product-header .icon-c').each(function (i, el) {
      if (el !== curEl) {
        $(el).removeClass('hovered')
      }
    })

  })
  $("body").click(function (e) {
    if (!$(e.target).closest('.icon-c').length) {
      $(".part-single-product-header .icon-c").removeClass('hovered');
    }
  });

}

